<app-simple-modal [title]="'Formulario de cierres contables'" [max]="90" [requiredFields]="false" (close)="close.emit($event)">
	<div fields>
		<div class="row">
            <div class="col-md-4" *ngFor="let form of formList">
                <div style="background: #f0f8ff05;" class="panel erp-panel">
                    <div class="panel-heading erp-panel-heading">
                        <h5 class="center-txt">
                            <i class="fa fa-calendar" aria-hidden="true"></i> {{form.formName + " - " + form.formCode}}</h5>
                    </div>
                    <div class="panel-body erp-panel-body">
                        <div class="row">
                            <div class="">
                                <form name="invoiceForm" class="ng-pristine ng-valid ng-valid-date ng-valid-required">
									<div class="form-height">
										<div class="progress info">
											<div class="progress-bar bg-success" role="progressbar" [style]="form.status==40?'width: 100%;':'width: 15%;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
											<div *ngIf="form.totalToPay>0" class="progress-bar bg-success" role="progressbar" style="width: 55%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
										</div>
										<ng-container *ngIf="form.status != 40 && form.status != 31">
											<p *ngIf="form.totalToPay<=0" class="info">
												Este formulario está siendo generado,
												te notificaremos cuando esté disponible
												para que procedas a pagarlo.
											</p>
											<p *ngIf="form.totalToPay>0" class="info">
	
												El formulario ha sido generado,
												por favor notifícanos cuando ya lo hayas pagado.
	
											</p>
										</ng-container>
										<p class="info" *ngIf="form.status == 40">
											Tu declaración de impuestos ha sido procesada exitosamente.
										</p>
										<p class="info" *ngIf="form.status == 31">
											Este formulario tiene un error.
										</p>
										<div class="row">
											<div class="col">
												<div class="row">
													<div class="col subtitle">
														Fecha:
													</div>
													<div class="col field">
														{{form.creationDate | date: 'dd/MM/YYYY'}}
													</div>
												</div>
												<div class="row">
													<div class="col subtitle">
														No: 
													</div>
													<div class="col field">
														{{form.formNumber ? form.number : (form.status!=40)?'En proceso':'No disponible'}}
													</div>
												</div>
												<div class="row">
													<div class="col subtitle">
														Acceso:
													</div>
													<div class="col field">
														{{form.formAccess ? form.formAccess : (form.status!=40 && form.status != 31)?'En proceso':'No disponible'}}
													</div>
												</div>
												<!-- <p class="info"> <strong>Fecha:       </strong>{{form.creationDate | date: 'dd/MM/YYYY'}}                </p>
												<p class="info"> <strong>No:          </strong>{{form.formNumber ? form.number : (form.status!=40)?'En proceso':'No disponible'}}      </p>
												<p class="info"> <strong>Acceso:      </strong>{{form.formAccess ? form.formAccess : (form.status!=40 && form.status != 31)?'En proceso':'No disponible'}} </p> -->
											</div>
											<div class="col">
												<p class="h5 text-center">{{form.totalToPay | currency : 'Q. '}}</p>
												<p class="text-center text-muted">Total</p>
											</div>
										</div>
										<p><span class="subtitle">Descripción: </span><span class="field">{{form.description}}</span></p>
										<div *ngIf="form.totalToPay > 0 && (form.status == 10 || form.status == 20 || form.status == 21 || form.status == 30)">
											<div class="buttons-tax">
												<!-- <button class="btn btn-success" *ngIf="form.status != 30"
														type="button" (click)="readyToPay(form.id)">
													<i class="fa fa-circle-check"></i> Ya pague
												</button> -->
												<app-loading-button [logo]="true" [colorLoading]="'white'" [object]="form.paying" *ngIf="form.status != 30" (clicked)="readyToPay(form)"></app-loading-button>
												<!-- <button class="btn btn-info"
														type="button" (click)="downloadForm(form.id)">
													<i class="fa fa-download"></i> SAT-200
												</button> -->
												<app-loading-button [logo]="true" [object]="form.downloading" (clicked)="downloadForm(form)"></app-loading-button>
											</div>
										</div>
										<!-- <button class="btn btn-info" *ngIf="form.status == 31 || form.status == 40" (click)="downloadForm(form.id)">
											<i class="fa fa-download" aria-hidden="true"></i> Descargar</button> -->
										<app-loading-button [logo]="true" *ngIf="form.status == 31 || form.status == 40" 
										[object]="form.downloading" (clicked)="downloadForm(form)"></app-loading-button>
									</div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" *ngIf="formList.length === 0">
                <br>
                <p class="center-text"><i class="fa fa-info-circle" aria-hidden="true"></i> No se han generado formularios aún</p>
            </div>

        </div>

	</div>
</app-simple-modal>